import { withErrorBoundary } from "@sentry/react";

import ErrorFallback from "@components/error-fallback/error-fallback";
import { sanitizeMarkdown } from "@helpers/string";

import {
  AssessmentResponseData,
  extractTextFromContent,
  getStreamingAssessmentResponseText,
  splitAssessmentResponseTags,
} from "../helpers";
import AskAIMessageMarkdown from "./ask-ai-message-markdown";
import AskAISuggestedAssessmentResponses, {
  AskAISuggestedAssessmentResponseStreaming,
} from "./ask-ai-suggested-assessment-responses";

const AskAIMessageContentComponent = ({
  content,
  isStreaming = false,
  chatSessionId,
  messageId,
  canEditSuggestedAssessmentResponse = false,
}: {
  content: string;
  isStreaming?: boolean;
  chatSessionId?: number | null;
  messageId: string;
  canEditSuggestedAssessmentResponse?: boolean;
}) => {
  const text = extractTextFromContent(content);
  const segments = splitAssessmentResponseTags(
    isStreaming ? sanitizeMarkdown(text) : text,
    { isStreaming },
  );
  const streamingAssessmentResponseText = isStreaming
    ? getStreamingAssessmentResponseText(text)
    : null;

  return (
    <div className="flex flex-col gap-4">
      {segments.map((segment, index) => {
        if (typeof segment === "string") {
          return segment ? (
            <div key={index} className="prose prose-sm max-w-none">
              <AskAIMessageMarkdown>{segment}</AskAIMessageMarkdown>
            </div>
          ) : null;
        }
        const assessment = segment as AssessmentResponseData;
        return (
          <AskAISuggestedAssessmentResponses
            key={`assessment-${index}`}
            suggestedAssessmentResponses={[
              {
                suggestedResponse: assessment.suggestedResponse,
                citations: assessment.citations,
                suggestionId: assessment.suggestionId,
              },
            ]}
            chatSessionId={chatSessionId || undefined}
            messageId={messageId}
            canBeEdited={canEditSuggestedAssessmentResponse}
          />
        );
      })}
      {streamingAssessmentResponseText !== null && (
        <AskAISuggestedAssessmentResponseStreaming
          suggestedResponse={streamingAssessmentResponseText}
        />
      )}
    </div>
  );
};

const AskAIMessageContent = withErrorBoundary(AskAIMessageContentComponent, {
  fallback: ErrorFallback,
});

export default AskAIMessageContent;
